import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { DateiArtsQuerySorterConfig } from 'fa-kt.types';
import { DateiArtsService } from '../service';

@Component({
  selector: 'fa-kt-datei-arts-sorter',
  templateUrl: './datei-arts-sorter.component.html',
  styleUrls: ['./datei-arts-sorter.component.css'],
})
export class DateiArtsSorterComponent {
  DateiArtsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public dateiArts: DateiArtsService,
  ) {
    this.DateiArtsSorterConfig = DateiArtsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
